import { Alert } from "antd";
import { TextService } from "../../Services/TextService";

// Shown on Status & Svar right after the event was created and designed. Short on purpose: the next
// steps are all in the menu to the left.
export const EventCreatedNextSteps = (props: { event: any }) => {
  const GetText = TextService.GetText;

  return <Alert
    type="success"
    showIcon
    message={<b>{GetText("MyEvents_CreatedTitle")}</b>}
    description={<>
      {GetText("MyEvents_CreatedNextSteps")}{" "}
      {props.event.eventLink ? <a href={props.event.eventLink} target="_blank" rel="noreferrer">{GetText("EventDesign_OpenEventPage")}</a> : ""}
    </>}
  />
}
